export default __webpack_public_path__ + "static/media/FF-1.e4597640.png";